import {useState} from "react";
import {Typography, IconButton, Grid, Box} from "@mui/material";
import styles from '../my-data.module.scss';
import {SearchZoomIn1, Trash} from "iconsax-react";
import NavButton from "../../content/shared/components/nav-btn";
import {observer} from "mobx-react";
import ViewImgModal from "./view-img-modal";
import DeleteImgModal from "./delete-img-modal";
import UploadImgModal from "./upload-img-modal";

const ImageCategory = observer(({uiStore}) => {

    // const [show, setShow] = useState(false);
    // const [, setLoading] = useState(false);
    const {images} = uiStore;
    const [selectedImg, setSelectedImg] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const viewImg = (img) => {
        setSelectedImg(img);
        setShowViewModal(true);
    }

    const deleteImg = (img) => {
        setSelectedImg(img);
        setShowDeleteModal(true);
    }

    // const toggleView = async () => {
    //     if (show) {
    //         setShow(false);
    //     } else {
    //         setShow(true);
    //         setLoading(false);
    //     }
    // }

    return (
        <>
            <NavButton children open sx={{boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 3%)',}}>
                <Typography sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '20px',
                    borderRadius: 0
                }} fontWeight='700'>
                    Images
                </Typography>

            </NavButton>


            <Grid container spacing={2} sx={{p: '20px'}} className={styles.imagesContainer}>
                <Grid item className={styles.cardImage}>
                    <UploadImgModal uiStore={uiStore}/>
                </Grid>
                {images?.map(img => (
                    <Grid item className={styles.cardImage}>
                        <Box key={img._id} className={styles.imgBlock}>
                            <img src={img.imgUrl} alt='person'/>
                            <Box className={styles.imgBlockActions}>
                                <IconButton color="white" onClick={() => viewImg(img)}>
                                    <SearchZoomIn1
                                        size="24"
                                        variant="Bulk"
                                    />
                                </IconButton>
                                <IconButton color="white" onClick={() => deleteImg(img)}>
                                    <Trash
                                        size="24"
                                        variant="Bulk"
                                    />
                                </IconButton>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <ViewImgModal show={showViewModal} setShow={setShowViewModal} img={selectedImg?.imgUrl}/>
            <DeleteImgModal show={showDeleteModal} setShow={setShowDeleteModal} img={selectedImg} uiStore={uiStore}/>

        </>
    );
});

export default ImageCategory;
